/**
 * §15 email normalisation: Unicode NFC, trim, lowercase the whole address.
 * No provider-specific rewriting (e.g. Gmail dots) – the participant's address is used as typed.
 * Emails are intentionally not globally unique (§12, §24).
 */
export function normalizeEmail(email: string): string {
  return email.normalize('NFC').trim().toLowerCase();
}

/**
 * §51/§65: masked email for UI and logs. `max.mustermann@gmail.com` → `m***@gmail.com`.
 * Invalid input is fully masked so that logs never contain a raw value.
 */
export function maskEmail(email: string): string {
  const trimmed = email.trim();
  const at = trimmed.lastIndexOf('@');
  if (at <= 0 || at === trimmed.length - 1) {
    return '***';
  }
  const first = Array.from(trimmed.slice(0, at))[0] ?? '';
  return `${first}***@${trimmed.slice(at + 1).toLowerCase()}`;
}
